import "./Portfolio.css";
import Hero from "../../components/Hero/Hero";
import SubHeading from "../../components/SubHeading/SubHeading";
import H1 from "../../components/H1/H1";
import ScrollAnimation from "../../components/ScrollAnimation/ScrollAnimation";
import usePageTitle from "../../hooks/usePageTitle";

const Portfolio = () => {
    usePageTitle("Portfolio");

    const portfolio = [
        {
            name: "Ratio Legal Capital",
            bg: "/images/portfolio/sydney.jpg",
            description:
                "Australian litigation funder focused on high-impact class actions with asymmetric returns.",
            image: "/images/logos/ratio-logo.svg",
            link: null,
        },
        {
            name: "Cador Wealth",
            bg: "/images/portfolio/london.jpg",
            description:
                "AI-led UK wealth advisory improving access, economics, and outcomes for clients and advisers.",
            image: "/images/logos/cador-logo.png",
            link: null,
        },
        {
            name: "keyd",
            bg: "/images/portfolio/dubai.jpg",
            description:
                "UAE PropTech platform providing hotels with on-demand project teams to track risk and lift profitability.",
            image: "/images/logos/keyd-logo.jpg",
            link: "https://www.keyd.co",
        },
        {
            name: "STUDIO Co",
            bg: "/images/portfolio/pilates.jpg",
            description:
                "UK boutique wellness group combining body, mind, and recovery in underserved commuter towns.",
            image: "/images/logos/studio-logo.jpg",
            link: "https://www.studioco.co.uk",
        },
    ];

    return (
        <div className="page-content portfolio-page">
            <Hero name="portfolio">
                <H1>Portfolio</H1>
            </Hero>

            <section className="padded">
                <div className="container">
                    <SubHeading>
                        "River's enduring impact is demonstrated by a flow of intelligence,
                        creativity, courage, and conviction. Stewarding capital and relationships
                        across generations while guiding those we reach to dream, execute, and give
                        back."
                    </SubHeading>

                    <div className="spacer"></div>

                    <div className="portfolio-list">
                        {portfolio.map((item, index) => (
                            <ScrollAnimation type="revealUp" delay={index * 100}>
                                <div
                                    className="portfolio-item"
                                    style={{ backgroundImage: `url(${item.bg})` }}
                                >
                                    {item.link && (
                                        <a
                                            href={item.link}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="portfolio-link-overlay"
                                        >
                                            &nbsp;
                                        </a>
                                    )}

                                    <div className="portfolio-overlay">
                                        <div className="portfolio-content">
                                            <div className="portfolio-name">{item.name}</div>

                                            <div className="portfolio-description">
                                                {item.description}
                                            </div>

                                            {/* {item.link && (
                                                <a
                                                    href={item.link}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="portfolio-link"
                                                >
                                                    <span>
                                                        <i className="fa-solid fa-arrow-right"></i>
                                                    </span>
                                                    Visit website
                                                </a>
                                            )} */}
                                        </div>
                                    </div>
                                </div>
                            </ScrollAnimation>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Portfolio;
